import { fork, takeEvery, all } from 'redux-saga/effects';
import config from '../../../config/config';
import { LogControllerDtoNftRepairLogListRequest, PerplayLogApi } from '../../models/src';
import { NFT_REPAIR_LOG_LIST_REQUEST } from '../../constants/log/nftRepairLogConstants';
import { getErrorMessage } from '../../../utils/serverErrorCheck';
import LogControllerDtoNftRepairLogListResponse from '../../models/src/model/LogControllerDtoNftRepairLogListResponse';

const api = new PerplayLogApi(config.API_CLIENT);

function* nftRepairLogListRequestSaga(payload) {
  console.assert(payload.callback, {
    message: 'callback이 설정되지 않았습니다.',
  });

  try {
    const requestData = new LogControllerDtoNftRepairLogListRequest();
    requestData.page = payload.page;
    requestData.pageLength = payload.pageLength;
    requestData.beginDate = payload.beginDate;
    requestData.endDate = payload.endDate;
    requestData.account = payload.account;
    requestData.nftUid = payload.nftUid;
    requestData.transactionNo = payload.transactionNo;
    console.log('요청 데이터: ', requestData);

    const result = yield api.apiPerplayLogNftRepairLogListPost({ logControllerDtoNftRepairLogListRequest: requestData }, () => {});
    const data = api.apiClient.deserialize(result, LogControllerDtoNftRepairLogListResponse);

    if (data.resultCode !== 200) {
      throw new Error(getErrorMessage(data));
    }
    payload.callback(data);
  } catch (e) {
    payload.error(e);
  }
}

function* nftRepairLogRootSaga() {
  yield all([
    takeEvery(NFT_REPAIR_LOG_LIST_REQUEST, nftRepairLogListRequestSaga),
  ]);
}

const nftRepairLogSaga = [
  fork(nftRepairLogRootSaga),
]

export default nftRepairLogSaga;
